module.exports = __webpack_public_path__ + "static/media/times-circle-regular.76811cec.svg";